import { render } from "./AlertComponent.vue?vue&type=template&id=da48f56a&scoped=true&ts=true"
import script from "./AlertComponent.vue?vue&type=script&lang=ts"
export * from "./AlertComponent.vue?vue&type=script&lang=ts"

import "./AlertComponent.vue?vue&type=style&index=0&id=da48f56a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da48f56a"]])

export default __exports__